module.exports = __webpack_public_path__ + "img/mustard.50ea8176.png";